import { render, staticRenderFns } from "./fixture.vue?vue&type=template&id=a5939cf6&"
import script from "./fixture.vue?vue&type=script&lang=js&"
export * from "./fixture.vue?vue&type=script&lang=js&"
import style0 from "./fixture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports